import axios from "axios";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import storage from "services/storage";
import constants from "constants";
import actions from "actions";

const { updateUser } = actions;

const { API_LOGIN } = constants;

const apiLogin = (email, password) =>
  axios.post(API_LOGIN, {
    email: email,
    password: password,
  });

const writeAuthSessionToStorage = (user, session) => {
  storage.setSessionData(user, session);
};

function* loginStory(email, password) {
  const response = yield call(apiLogin, email, password);

  const user = response.data.user;
  const session = {
    token: response.data.token,
  };

  yield put(updateUser(user, session));

  yield call(writeAuthSessionToStorage, user, session);
  return response;
}

export { loginStory };



// WEBPACK FOOTER //
// ./src/sagas/stories/login.js